import React from "react";
import Button from "../../components/shared/button";
import ListView from "../../components/shared/list/listView";
import { TopToolbar } from "../../components/shared/list/topToolbar";
import {
  ListViewType,
  useList,
} from "../../components/shared/list/useListHook";
import { Text } from "../../components/shared/text";

import sampleImage1 from "../../styles/images/samples/sample_1.jpg";
import sampleImage2 from "../../styles/images/samples/sample_2.jpg";
import sampleImage3 from "../../styles/images/samples/sample_3.jpg";
import sampleImage4 from "../../styles/images/samples/sample_4.jpg";
import sampleImage5 from "../../styles/images/samples/sample_5.jpg";
import sampleImage6 from "../../styles/images/samples/sample_6.jpg";
import sampleImage7 from "../../styles/images/samples/sample_7.jpg";
import sampleImage8 from "../../styles/images/samples/sample_8.jpg";
import sampleImage9 from "../../styles/images/samples/sample_9.jpg";
import sampleImage10 from "../../styles/images/samples/sample_10.jpg";
import sampleImage11 from "../../styles/images/samples/sample_11.jpg";
import sampleImage12 from "../../styles/images/samples/sample_12.jpg";

/*import ItemImage1 from "../../styles/images/samples/sample_12.jpg"*/

// import ItemImage1 from "../../styles/images/items/item_1.png";
 import ItemImage2 from "../../styles/images/items/item_2.png";
// import ItemImage3 from "../../styles/images/items/item_3.png";
// import ItemImage4 from "../../styles/images/items/item_4.png";



import Marquee from "../../components/Marquee";
import Ripple from "../../components/Ripple";
import { SvgDownload } from "components/svg";

const getRandomImage = () => {
  const sampleImages = [
    sampleImage1,
    sampleImage2,
    sampleImage3,
    sampleImage4,
    sampleImage5,
    sampleImage6,
    sampleImage7,
    sampleImage8,
    sampleImage9,
    sampleImage10,
    sampleImage11,
    sampleImage12,
  ];
  const randomIndex = Math.floor(Math.random() * sampleImages.length);
  return sampleImages[randomIndex];
};

const getRandomName = () => {
  const RandomName = [
    "Bruce Banner",
    "Tony Stark",
    "Natasha Romanoff",
    "Thor Odinson",
    "Steve Rogers",
    "Yondu Udonta",
  ];
  const randomIndex = Math.floor(Math.random() * RandomName.length);
  return RandomName[randomIndex];
};

type DemoItem = {
  key: number;
  name: string;
  age: number;
  address: string;
  description: string;
  image: string;
};
const dataSource: DemoItem[] = [];

for (let i = 1; i <= 15; i++) {
  dataSource.push({
    key: i,
    name: getRandomName(),
    age: Number(`${i}2`),
    address: `${i}720 Goodrich Ct Platteville, Colorado`,
    description: `Mauris justo auctor in sollicitudin convallis  gravida non tortor etiam et vehicula elit`,
    image: getRandomImage(),
  });
}

const BlockItem: React.FC<{ data: DemoItem }> = ({ data }) => (
  <group
    data-direction="column"
    data-contain=""
    data-border=""
    data-radius="10"
    data-background="context"
    // data-react="scale"
    data-cursor="pointer"
  >
    <group data-ratio="5:4" data-shrink="no" data-contain="">
      {/* <text data-position="absolute" data-index="2" data-space-horizontal="20" data-color="white" data-text-size="64" data-weight="800" data-bottom="0">{data.key}</text> */}
      <picture >
        <img src={data.image} alt="" />
      </picture>
    </group>
    <group data-direction="column" data-contain="" data-gap="5" data-space="15">
      <Text
        data-text-size="medium"
        data-weight="700"
        data-color="main"
        data-ellipsis=""
      >
        {data.name}
      </Text>
      <Text data-wrap="wrap" data-clamp="3" data-line="1.5">
        {data.description}
      </Text>
    </group>
    <separator data-horizontal="" data-margin="none"></separator>
    <group data-gap="5" data-space="10" data-align="center" data-justify="end" >
      <Button material text="Open" />

      <separator data-vertical=""></separator>
      <Button micro material icon="arrow_outward" />
    </group>
  </group>
);

const ListItem: React.FC<{ data: DemoItem }> = ({ data }) => (
  <Ripple>
    <group
      data-align="center"
      data-space="5"
      data-gap="5"
      data-wrap="no"
      data-radius="10"
      data-contain=""
      data-cursor="pointer"
    >
      <group data-ratio="1:1" data-length="50" data-shrink="no" data-index="1">
        <picture data-radius="5">
          <img src={data.image} alt="" />
        </picture>
      </group>
      <group data-direction="column" data-contain="" data-space="5" data-index="1">
        <Text data-weight="700" data-ellipsis="">
          {data.name}
        </Text>
        <Marquee>
          <Text data-ellipsis="" data-light="">
            {data.description}
          </Text>
        </Marquee>
      </group>
      <separator data-vertical=""></separator>
      <group
        data-align="center"
        data-wrap="no"
        data-position="right"
        data-width="auto"
        data-index="1"
      >
        <Button mini rounded>
          <icon>more_vert</icon>
        </Button>
      </group>
    </group>
  </Ripple>
);

const GridItem: React.FC<{ data: DemoItem }> = ({ data }) => (
  <group data-align="center" data-space="10" data-gap="10" data-wrap="no">
    <group data-ratio="1:1" data-length="50" data-shrink="no">
      <picture>
        <img data-radius="5" src={data.image} alt="" />
      </picture>
    </group>
    <group data-direction="column" data-contain="">
      <Text data-weight="700">{data.name}</Text>
      <Text data-ellipsis="">{data.description}</Text>
    </group>
    <separator data-vertical=""></separator>
    <group
      data-align="center"
      data-wrap="no"
      data-position="right"
      data-width="auto"
    >
      <Button mini rounded>
        <icon>more_vert</icon>
      </Button>
    </group>
  </group>

);

const ListViewDemo: React.FC = () => {
  const { toolbarProps } = useList({
    viewTypes: [ListViewType.Block, ListViewType.List, ListViewType.Grid],
    defaultViewType: ListViewType.Block,
  });
  return (
    <view data-vertical="">
      <view
        data-vertical="true"
        //  data-space="20"
        data-background="highlight"
      //  data-align="start"
      >
        <group
          data-border=""
          //  data-radius="10"
          data-contain=""
          data-background="main-background"
          data-wrap="no"
          data-direction="column"
          data-max-height="fit"
        >
          <TopToolbar {...toolbarProps} />
          {toolbarProps.viewType === ListViewType.Block && (
            <ListView
              dataSource={dataSource}
              view={ListViewType.Block}
              keyField="key"
              data-template="190"
              scrollerProps={{ "data-space": "20" }}
              listProps={{ "data-gap": "10" }}
              itemComponent={BlockItem}
            />
          )}
          {toolbarProps.viewType === ListViewType.Grid && (
            <ListView
              view={ListViewType.Grid}
              dataSource={dataSource}
              keyField="key"
              data-space="10"
              itemComponent={GridItem}
            />
          )}
          {toolbarProps.viewType === ListViewType.List && (
            <ListView
              data-template="200"
              view={ListViewType.List}
              dataSource={dataSource}
              keyField="key"
              data-space="5"
              listProps={{ "data-space": "10", "data-gap": "10" }}
              itemComponent={ListItem}
            />
          )}
          <group
            data-border="overprint"
            data-align="center"
            data-gap="10"
            data-space="10"
            data-index="2"
          >
            <icon>arrow_outward</icon>
            <text>Footer Goes Here</text>
          </group>
        </group>
      </view>
      <view>
        <div className="list_view_container" data-scroll="" data-template="450" view="block">
          <group className="list_view_scroller" data-space="20">
            <div className="list_view" data-gap="10">
              <div className="item custom" data-border="" data-radius="5" data-contain="">
                <group data-direction="column">

                  <group data-align="center" data-gap="5" data-background="accent-xtralight" data-space="10" data-space-horizontal="20">
                    <text data-uppercase="" data-weight="600">Appoints</text>
                    <div className="button accent" data-height="40" data-position="right" data-background="white">
                      <group data-align="center" data-justify="center" data-gap="10">
                        <icon data-svg-size="16" >
                          <SvgDownload />
                        </icon>
                        <text data-width="auto">Document & notices</text>
                      </group>
                    </div>
                  </group>
                  <group data-space="20" data-gap="20">
                    <group data-ratio="1:1" data-shrink="no" data-contain="" data-length="100" data-space="10" data-border="" data-radius="5"><picture><img src={ItemImage2} alt="" /></picture></group>
                    <group data-name="cost" data-align="center"><text data-text-size="22">1234€</text></group>
                    <text data-wrap="wrap" data-line="20" data-light="" >Menus are visual displays that present a list of options or choices on surfaces that are temporary or can change.</text>

                    <group data-width="auto" data-direction="column" data-radius="5" data-contain="">
                      <group data-wrap="no" data-width="auto">
                        <group data-length="260" data-height="40" data-space-horizontal="10" data-align="center" data-fit="2" data-background="main" data-color="white">
                          <text data-position="left" data-weight="600">21 kW</text>
                        </group>
                        <group data-length="260" data-height="40" data-space-horizontal="10" data-align="center" data-fit="1">
                          <text data-position="left" data-color="grey-color-dark" data-weight="600">6 kW</text>
                        </group>
                      </group>
                      <group data-wrap="no" data-width="auto">
                        <group data-length="260" data-height="40" data-space-horizontal="10" data-align="center" data-fit="2" data-background="main" data-color="white">
                          <text data-position="left" data-weight="600">21 kW</text>
                        </group>
                        <group data-length="260" data-height="40" data-space-horizontal="10" data-align="center" data-fit="1">
                          <text data-position="left" data-color="grey-color-dark" data-weight="600">6 kW</text>
                        </group>
                      </group>
                      <group data-wrap="no" data-width="auto">
                        <group data-length="260" data-height="40" data-space-horizontal="10" data-align="center" data-fit="2" data-background="accent-dark" data-color="white">
                          <text data-position="left" data-weight="600">21 kW</text>
                        </group>
                        <group data-length="260" data-height="40" data-space-horizontal="10" data-align="center" data-background="accent-semilight" data-fit="1">
                          <text data-position="left" data-color="grey-color-dark" data-weight="600">6 kW</text>
                        </group>
                      </group>
                    </group>
                  </group>
                </group>
              </div>
            </div>
          </group>
        </div>

      </view>

      { /* <view>
     <div className="list_view_container" data-scroll="" data-template="260">
          <group className="list_view_scroller" data-space="20">
            <div className="list_view">
              <div className="item custom" data-border="" data-length="260">
                <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                  <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                  <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                  <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                  <group data-space-vertical="20" data-justify="center">
                    <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage1} alt=""/></picture></group>
                  </group>
                  <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                </group>
              </div>

              <div className="item custom" data-border="" data-length="260">
                <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                  <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                  <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                  <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                  <group data-space-vertical="20" data-justify="center">
                    <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage2} alt=""/></picture></group>
                  </group>
                  <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                </group>
              </div>

              <div className="item custom" data-border="" data-length="260">
                <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                  <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                  <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                  <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                  <group data-space-vertical="20" data-justify="center">
                    <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage3} alt=""/></picture></group>
                  </group>
                  <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                </group>
              </div>

              <div className="item custom" data-border="" data-length="260">
                <group data-direction="column" data-align="center" data-gap="10" data-space="20" data-space-top="0">
                  <group data-name="title" data-length="180" data-height="40" data-align="center" data-justify="center" data-gap="5" data-background="accent-xtralight" data-radius-bottom="10"><text data-uppercase="" data-weight="600">Nom de proposition 1</text></group>
                  <group data-radius="3" data-background="main" data-color="white" data-height="40" data-align="center" data-justify="center" data-gap="5"><icon>check</icon><text data-width="auto">Sélectionner cette proposition</text></group>
                  <group><div className="button fit accent" data-radius="3" data-height="40"><group data-align="center" data-justify="center" data-gap="5"><icon>visibility</icon><text data-width="auto">Détail de la solution</text></group></div></group>
                  <group data-space-vertical="20" data-justify="center">
                    <group data-ratio="5:4" data-shrink="no" data-contain="" data-length="140"><picture><img src={ItemImage4} alt=""/></picture></group>
                  </group>
                  <group data-name="cost" data-align="center" data-justify="center"><text data-text-size="22">1234€</text></group>
                </group>
              </div>
            </div>
          </group>
        </div>

      </view>*/}
      {/* <view data-adaptive="desktop"></view> */}
    </view>
  );
};
export default ListViewDemo;
